import React, { useState, useEffect } from "react";
import axios from "axios";
import DefaultImage from "../assets/img/icon1.png";
import ProfileDefaultImage from "../assets/img/profile.png";
import { SubmitButton } from "../components/Input";
import { showToast } from "../components/toast";
import { API_URL } from "../config";

const EditProfile = () => {
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(null);

  const [form, setForm] = useState({
    user_email: "",
    user_dob: "",
    user_pan: "",
    bank_name: "",
    bank_ifsc: "",
    bank_account: "",
    name_in_bank: "",
    iscompleted: false,
  });

  const [images, setImages] = useState({
    user_image: null,
    user_aadhar_image: null,
    user_pan_image: null,
  });

  const [previews, setPreviews] = useState({
    user_image: DefaultImage,
    user_aadhar_image: DefaultImage,
    user_pan_image: DefaultImage,
  });

  useEffect(() => {
    const fetchUserId = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) return showToast.error("No auth token found.");
      try {
        const response = await axios.get(`${API_URL}auth/role-detail`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const id = response?.data?.data?.id;
        if (id) setUserId(id);
        else showToast.error("User ID not found.");
      } catch {
        showToast.error("Failed to fetch user id.");
      }
    };
    fetchUserId();
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem("authToken");
      if (!token || !userId) return;
      setLoading(true);
      try {
        const resp = await axios.get(`${API_URL}user/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (resp.data.success) {
          const u = resp.data.data.user;
          setForm({
            user_email: u.user_email || "",
            user_dob: u.user_dob || "",
            user_pan: u.user_pan || "",
            bank_name: u.bank_name || "",
            bank_ifsc: u.bank_ifsc || "",
            bank_account: u.bank_account || "",
            name_in_bank: u.name_in_bank || "",
            iscompleted: u.iscompleted === 1,
          });
          setPreviews({
            user_image: u.user_image || DefaultImage,
            user_aadhar_image: u.user_aadhar_image || DefaultImage,
            user_pan_image: u.user_pan_image || DefaultImage,
          });
        } else {
          showToast.error(resp.data.message || "Failed to fetch user");
        }
      } catch {
        showToast.error("Error fetching user data.");
      } finally {
        setLoading(false);
      }
    };
    if (userId) fetchUser();
  }, [userId]);

  const handleImageChange = (field) => (e) => {
    const file = e.target.files[0];
    if (file) {
      setImages((prev) => ({ ...prev, [field]: file }));
      setPreviews((prev) => ({ ...prev, [field]: URL.createObjectURL(file) }));
    }
  };

  const handleChange = (field) => (e) => {
    const value = field === "iscompleted" ? e.target.checked : e.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("authToken");
    if (!token || !userId) {
      return showToast.error("No auth token or user id.");
    }

    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      formData.append(key, value);
    });
    Object.entries(images).forEach(([key, file]) => {
      if (file) formData.append(key, file);
    });

    setLoading(true);
    try {
      const response = await axios.put(
        `${API_URL}user/update-user/${userId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success) {
        showToast.success("Profile updated successfully!");
      } else {
        showToast.error(response.data.message || "Failed to update profile.");
      }
    } catch (err) {
      showToast.error("Error updating profile.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="panel panel-default with-rounded-corner with-shadow mt-5">
      <form
        onSubmit={handleSubmit}
        className="stdform"
        encType="multipart/form-data"
      >
        <fieldset>
          <div className="panel-heading border-0">
            <span className="panel-title">Edit Profile</span>
          </div>
          <div className="panel-body">
            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="form-label semibold">Personal Email</label>
                <input
                  type="email"
                  value={form.user_email}
                  onChange={handleChange("user_email")}
                  className="form-control"
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label semibold">DOB</label>
                <input
                  type="date"
                  value={form.user_dob}
                  onChange={handleChange("user_dob")}
                  className="form-control"
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label semibold">User PAN</label>
                <input
                  type="text"
                  value={form.user_pan}
                  onChange={handleChange("user_pan")}
                  className="form-control"
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label semibold">Bank Name</label>
                <input
                  type="text"
                  value={form.bank_name}
                  onChange={handleChange("bank_name")}
                  className="form-control"
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label semibold">Bank IFSC</label>
                <input
                  type="text"
                  value={form.bank_ifsc}
                  onChange={handleChange("bank_ifsc")}
                  className="form-control"
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label semibold">Bank Account</label>
                <input
                  type="text"
                  value={form.bank_account}
                  onChange={handleChange("bank_account")}
                  className="form-control"
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label semibold">Name as per Bank</label>
                <input
                  type="text"
                  value={form.name_in_bank}
                  onChange={handleChange("name_in_bank")}
                  className="form-control"
                />
              </div>
            </div>
            {/* Uploads */}
            <div className="col-md-5 mb-3">
              <label>User Image</label>
              <div className="d-flex align-items-center">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange("user_image")}
                  className="form-control"
                />
                {previews.user_image &&
                  previews.user_image !== DefaultImage && (
                    <a
                      href={previews.user_image}
                      download
                      className="btn btn-sm btn-outline-primary ms-2"
                      title="Download User Image"
                      target="_blank" // Optional: open in new tab
                      rel="noopener noreferrer"
                    >
                      Download
                    </a>
                  )}
              </div>
            </div>

            <div className="col-md-5 mb-3">
              <label>Aadhar Image</label>
              <div className="d-flex align-items-center">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange("user_aadhar_image")}
                  className="form-control"
                />
                {previews.user_aadhar_image &&
                  previews.user_aadhar_image !== DefaultImage && (
                    <a
                      href={previews.user_aadhar_image}
                      download
                      className="btn btn-sm btn-outline-primary ms-2"
                      title="Download Aadhar Image"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download
                    </a>
                  )}
              </div>
            </div>

            <div className="col-md-5 mb-3">
              <label>PAN Image</label>
              <div className="d-flex align-items-center">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange("user_pan_image")}
                  className="form-control"
                />
                {previews.user_pan_image &&
                  previews.user_pan_image !== DefaultImage && (
                    <a
                      href={previews.user_pan_image}
                      download
                      className="btn btn-sm btn-outline-primary ms-2"
                      title="Download PAN Image"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download
                    </a>
                  )}
              </div>
            </div>

            <SubmitButton pageBack="/profile" handleSubmit={handleSubmit} />
          </div>
        </fieldset>
      </form>

      {/* Image Preview */}
      <div className="row mb-4 mt-5">
        <div className="col-md-4 mb-3">
          <img
            src={previews.user_image || ProfileDefaultImage}
            alt="User"
            style={{ width: "100%" }}
          />
        </div>
        <div className="col-md-4 mb-3">
          <img
            src={previews.user_aadhar_image}
            alt="Aadhar"
            style={{ width: "100%" }}
          />
        </div>
        <div className="col-md-4 mb-3">
          <img
            src={previews.user_pan_image}
            alt="PAN"
            style={{ width: "100%" }}
          />
        </div>
      </div>
      {loading && <div>Loading...</div>}
    </div>
  );
};

export default EditProfile;
